import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 't2ymmbamjyflnuszctozbyy1ewhpuu';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <SalesPage data-id="element-0" />;
}